import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { InviteUtilisateurDialogComponent } from './invite-utilisateur-dialog/invite-utilisateur-dialog.component';
import { ScormService } from 'src/services/scorm.service';
import { UtilisateurPilotageModel } from 'src/models/pilotage/utilisateurPilotageModel';
import { UtilisateurListPilotageModel } from 'src/models/pilotage/utilisateurListPilotageModel';
import { AuthService } from 'src/services/auth.service';
import { InviteAdminPiloteDialogComponent } from './invite-admin-pilote-dialog/invite-admin-pilote-dialog.component';
import { ResultDesactiverUtilisateursModel } from 'src/models/pilotage/resultDesactiverUtilisateursModel';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChoixEntiteActiverDialogComponent } from './choix-entite-activer-dialog/choix-entite-activer-dialog.component';
import { DesactiverUtilisateursModel } from 'src/models/pilotage/desactiverUtilisateursModel';
import { ConfirmationDesactiverDialogComponent } from './confirmation-desactiver-dialog/confirmation-desactiver-dialog.component';
import { InviterUtilisateursModel } from 'src/models/pilotage/inviterUtilisateursModel';
import { ConfirmationReenvoiInvitationDialogComponent } from './confirmation-reenvoi-invitation-dialog/confirmation-reenvoi-invitation-dialog.component';
import { CreerUtilisateursFictifsDialogComponent } from './creer-utilisateurs-fictifs-dialog/creer-utilisateurs-fictifs-dialog.component';
import { CreerUtilisateurTenantSSODialogComponent } from './creer-utilisateur-tenant-sso-dialog/creer-utilisateur-tenant-sso-dialog.component';
import { CreerAdminPiloteTenantSSODialogComponent } from './creer-admin-pilote-tenant-sso-dialog/creer-admin-pilote-tenant-sso-dialog.component';
import { ConfirmationForcerMdpDialogComponent } from './confirmation-forcer-mdp-dialog/confirmation-forcer-mdp-dialog.component';
import { ForcerMotDePasseModel } from 'src/models/pilotage/forcerMotDePasseModel';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommunEtiquetteComponent } from './commun-etiquette/commun-etiquette.component';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { EtiquetteService } from 'src/services/etiquette.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { TiretPipe } from 'src/app/pipe/tiret.pipe';
import { CustomDateHeurePipe } from 'src/app/pipe/dateHeure.pipe';
import { EntiteModel, EtiquetteModel } from 'src/models/pilotage/contextePilotageUtilisateurModel';
import { ConfirmationExportDialogComponent } from '../../../commun/dialog/confirmation-export-dialog/confirmation-export-dialog.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorIntlService } from 'src/services/custom-paginator-intl.service';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { StatePersistenceService } from 'src/services/state-persistence.service';
import { UtilisateursManagmentState, validateUtilisateursManagmentState } from 'src/models/utilisateurs-managment-state.model';
import { EEntite } from 'src/enum/eEntite';
import { EmptyStringPipe } from 'src/app/pipe/EmptyString.pipe';
import { DetailInvitationDialogComponent } from './detail-invitation-dialog/detail-invitation-dialog.component';
import moment from 'moment';

@Component({
    selector: 'app-utilisateurs-managment',
    templateUrl: './utilisateurs-managment.component.html',
    styleUrls: ['./utilisateurs-managment.component.scss'],
    imports: [
        MatProgressSpinnerModule,
        TranslateModule,
        CommonModule,
        FormsModule,
        MatIconModule,
        CustomDateHeurePipe,
        MatSelectModule,
        NgxMatSelectSearchModule,
        ReactiveFormsModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatTableModule,
        MatPaginator,
        MatSortModule,
        MatButtonModule,
        MatMenuModule,
        EmptyStringPipe,
        MatPseudoCheckboxModule
    ],
    providers: [
        {
            provide: MatPaginatorIntl,
            useClass: CustomPaginatorIntlService
        }
    ]
})
export class UtilisateursManagmentComponent implements OnInit, OnDestroy {
  utilisateurs: UtilisateurListPilotageModel[] = [];
  utilisateursAffiches: UtilisateurListPilotageModel[] = [];
  utilisateursFiltreEncours: UtilisateurListPilotageModel[] = [];

  readonly DEMO_USER_LIMIT = 10;

  allSelected: boolean = false;
  anySelected: boolean = false;
  possedeInvitationEnAttente: boolean = false;

  displayedColumns: string[] = [
    'choix',
    'nom',
    'email',
    'etat',
    'role-entreprise',
    'etiquettes',
    'dateDerniereConnexion',
    'actions'
  ];

  pageIndex: number = 0;
  pageSize: number = 10;
  currentPage: number = 0;
  totalItems: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  showEtiquettesMenu: boolean = false;

  entites: EntiteModel[] = [];

  etiquettes: EtiquetteModel[] = [];

  selectedEntreprises: EntiteModel[] = [];
  selectedNames: string[] = [];
  selectedEmails: string[] = [];
  selectedRoles: string[] = [];
  selectionEtiquette: number[] = [];
  filter: 'all' | 'active' | 'inactive' | 'invitation' = 'active';
  searchTerm: string = '';

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' | '' = '';

  names: string[] = [];
  roles: string[] = [];
  emails: string[] = [];

  isLoading: boolean = false;
  estUtilisateurPilote: boolean = false;

  afficherFiltreMobile: boolean = false;
  afficherFiltreBureau: boolean = true;

  dataSource!: MatTableDataSource<UtilisateurListPilotageModel>;
  protected _onDestroy = new Subject<void>();

  entiteFilterCtrl: FormControl = new FormControl();
  filteredEntites: ReplaySubject<EntiteModel[]> = new ReplaySubject<EntiteModel[]>(1);


  etiquetteFilterCtrl: FormControl = new FormControl();
  filteredEtiquettes: ReplaySubject<EtiquetteModel[]> = new ReplaySubject<EtiquetteModel[]>(1);

  nameFilterCtrl: FormControl = new FormControl();
  filteredNames: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);

  emailFilterCtrl: FormControl = new FormControl();
  filteredEmails: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);

  roleFilterCtrl: FormControl = new FormControl();
  filteredRoles: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  private readonly COMPONENT_KEY = 'utilisateurs-managment';

  constructor(
    private router: Router,
    private dialog: MatDialog,
    public utilisateurService: UtilisateurService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    public etiquetteService: EtiquetteService,
    private statePersistenceService: StatePersistenceService
  ) {
    translate.setDefaultLang('fr');
    this.dataSource = new MatTableDataSource<UtilisateurListPilotageModel>([]);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const isInsideMenu = target.closest('.menu-container');
    if (!isInsideMenu) {
      this.utilisateursFiltreEncours.forEach(tag => tag.isMenuOpen = false);
    }
  }

  ngOnInit(): void {
    if (this.utilisateurService.entiteUtilisateurSelectionnee.entiteId === EEntite.ROOT_ENTITE_ID) {
      this.router.navigate(['/utilisateurs-root-managment']);
      return;
    }

    this.estUtilisateurPilote = this.estPilote();

    this.chargementUtilisateurs().then(() => {
      setTimeout(() => {
        this.initializeFilteredOptions();
      }, 100);
    });

    this.entiteFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterEntites();
      });

    this.etiquetteFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterEtiquettes();
      });


    this.nameFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterNames();
      });

    this.emailFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterEmails();
      });

    this.roleFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRoles();
      });
  }

  ngOnDestroy() {
    this.saveState();
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  private filterEntites() {
    if (!this.entites) {
      return;
    }
    let search = this.entiteFilterCtrl.value;
    if (!search) {
      this.filteredEntites.next(this.entites.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredEntites.next(
      this.entites.filter(entite => entite.nom.toLowerCase().indexOf(search) > -1)
    );
  }

  private filterEtiquettes() {
    if (!this.etiquettes) {
      return;
    }
    let search = this.etiquetteFilterCtrl.value;
    if (!search) {
      this.filteredEtiquettes.next(this.etiquettes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredEtiquettes.next(
      this.etiquettes.filter(etq => this.getEtiquetteName(etq.etiquetteId).toLocaleLowerCase().indexOf(search) > -1)
    );
  }

  private filterNames() {
    if (!this.names) {
      return;
    }
    let search = this.nameFilterCtrl.value;
    if (!search) {
      this.filteredNames.next(this.names.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredNames.next(
      this.names.filter(name => name.toLowerCase().indexOf(search) > -1)
    );
  }

  private filterEmails() {
    if (!this.emails) {
      return;
    }
    let search = this.emailFilterCtrl.value;
    if (!search) {
      this.filteredEmails.next(this.emails.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredEmails.next(
      this.emails.filter(email => email.toLowerCase().indexOf(search) > -1)
    );
  }

  private filterRoles() {
    if (!this.roles) {
      return;
    }
    let search = this.roleFilterCtrl.value;
    if (!search) {
      this.filteredRoles.next(this.roles.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredRoles.next(
      this.roles.filter(role => role.toLowerCase().indexOf(search) > -1)
    );
  }

  private initializeFilteredOptions(): void {
    this.filteredEntites.next(this.entites.slice());
    this.filteredNames.next(this.names.slice());
    this.filteredEtiquettes.next(this.etiquettes.slice());
    this.filteredEmails.next(this.emails.slice());
    this.filteredRoles.next(this.roles.slice());
  }

  populateFilterOptions(): void {
    this.entites = [
      ...new Set(
        this.utilisateurs.flatMap(user =>
          user.tousLesRolesEntites.map(role => {
            const entite = this.utilisateurService.contexteUtilisateur.toutesLesEntites
              .find(e => e.entiteId === role.entiteId);
            return entite!;
          })
        )
      )
    ].sort((a, b) => (a.nom ?? '').localeCompare(b.nom ?? '', 'fr', { sensitivity: 'base' }));

    this.etiquettes = [
      ...new Set(
        this.utilisateurs.flatMap(user =>
          (user.toutesLesEtiquettes ?? [])
            .filter(etqId => etqId != null)
            .map(etqId => this.getEtiquette(etqId)).filter(etq => etq != null)
        )
      )
    ].sort((a, b) => this.getEtiquetteName(a.etiquetteId).localeCompare(this.getEtiquetteName(b.etiquetteId), 'fr', { sensitivity: 'base' }));

    this.names = [...new Set(this.utilisateurs.map(user => user.nom).filter(name => name !== null))]
      .sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));

    this.roles = [...new Set(this.utilisateurs.flatMap(user =>
      user.tousLesRolesEntites.map(role =>
        this.utilisateurService.obtenirDenominationRole(role.roleId)
      )
    ))].sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));

    this.emails = [...new Set(this.utilisateurs.map(user => user.email))]
      .sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
  }

  setFilter(newFilter: 'all' | 'active' | 'inactive' | 'invitation'): void {
    this.filter = newFilter;
    this.pageIndex = 0;
    this.resetSelections();
    this.applyFilters();
  }

  applyFilters(): void {
    this.pageIndex = 0;
    this.resetSelections();

    this.utilisateursFiltreEncours = this.utilisateurs.filter(user => this.applyUserFilter(user));

    this.utilisateursFiltreEncours.forEach(user => user.isMenuOpen = false);

    this.totalItems = this.utilisateursFiltreEncours.length;
    this.paginer();
    this.saveState();
  }

  sortDataChange(sortState: Sort) {
    const data = this.utilisateursFiltreEncours.slice();

    this.utilisateursFiltreEncours.forEach(user => user.isMenuOpen = false);

    if (!sortState.active || sortState.direction === '') {
      this.sortColumn = '';
      this.sortDirection = '';
      this.utilisateursFiltreEncours = [...this.utilisateurs.filter(user => {
        return this.applyUserFilter(user);
      })];
      this.paginer();
      this.saveState();
      return;
    }

    this.sortColumn = sortState.active;
    this.sortDirection = sortState.direction;

    this.utilisateursFiltreEncours = data.sort((a, b) => {
      const isAsc = sortState.direction === 'asc';

      switch (sortState.active) {
        case 'nom':
          const nomA = this.getNomForSort(a);
          const nomB = this.getNomForSort(b);
          return this.compareStrings(nomA, nomB, isAsc);

        case 'etat':
          const etatA = this.getEtatUtilisateur(a);
          const etatB = this.getEtatUtilisateur(b);
          return this.compareStrings(etatA, etatB, isAsc);

        case 'email':
          const emailA = a.email || '';
          const emailB = b.email || '';
          return this.compareStrings(emailA, emailB, isAsc);

        case 'dateDerniereConnexion':
          const dateA = a.dateDerniereConnexion ? new Date(a.dateDerniereConnexion).getTime() : 0;
          const dateB = b.dateDerniereConnexion ? new Date(b.dateDerniereConnexion).getTime() : 0;
          return this.compareNumbers(dateA, dateB, isAsc);

        case 'etiquettes':
          const etiquettesA = this.getEtiquettesForSort(a);
          const etiquettesB = this.getEtiquettesForSort(b);
          return this.compareStrings(etiquettesA, etiquettesB, isAsc);

        case 'role-entreprise':
          const rolesA = this.getRolesForSort(a);
          const rolesB = this.getRolesForSort(b);
          return this.compareStrings(rolesA, rolesB, isAsc);

        default:
          return 0;
      }
    });

    this.paginer();
    this.saveState();
  }

  private compareStrings(a: string, b: string, isAsc: boolean): number {
    const valueA = (a || '').toLowerCase().trim();
    const valueB = (b || '').toLowerCase().trim();

    const result = valueA.localeCompare(valueB, 'fr', {
      numeric: true,
      sensitivity: 'base',
      ignorePunctuation: true
    });

    return isAsc ? result : -result;
  }

  private compareNumbers(a: number, b: number, isAsc: boolean): number {
    const result = a - b;
    return isAsc ? result : -result;
  }

  private getNomForSort(user: UtilisateurListPilotageModel): string {
    if (user.estInvitationEnAttente) {
      return '';
    }
    return user.nom || '';
  }


  getEtatUtilisateur(user: UtilisateurListPilotageModel): string {
    if (!user.tousLesRolesEntites || user.tousLesRolesEntites.length === 0) {
      return this.translate.instant('USERS_MANAGEMENT.STATUS_INACTIF') || 'Inactif';
    }
    if (user.estInvitationEnAttente) {
      return this.translate.instant('USERS_MANAGEMENT.STATUS_INVITE') || 'Invité';
    }
    if (user.estActif) {
      return this.translate.instant('USERS_MANAGEMENT.STATUS_ACTIF') || 'Actif';
    }
    return '';
  }

  private getEtiquettesForSort(user: UtilisateurListPilotageModel): string {
    if (!user.toutesLesEtiquettes || user.toutesLesEtiquettes.length === 0) {
      return '';
    }

    return user.toutesLesEtiquettes
      .map(etiquetteId => this.getEtiquetteName(etiquetteId) || '')
      .filter(name => name.trim() !== '')
      .sort()
      .join(', ');
  }

  private getRolesForSort(user: UtilisateurListPilotageModel): string {
    if (!user.tousLesRolesEntites || user.tousLesRolesEntites.length === 0) {
      return '';
    }

    return user.tousLesRolesEntites
      .map(role => {
        const roleName = this.utilisateurService.obtenirDenominationRole(role.roleId) || '';
        const entityName = role.nomEntite || '';
        return `${roleName} - ${entityName}`;
      })
      .filter(roleString => roleString.trim() !== ' - ')
      .sort()
      .join(', ');
  }

  private applyUserFilter(user: UtilisateurListPilotageModel): boolean {
    const entiteMatch = !this.selectedEntreprises.length || (
      user.tousLesRolesEntites?.some(role =>
        this.selectedEntreprises.includes(
          this.utilisateurService.contexteUtilisateur.toutesLesEntites.find(e => e.entiteId === role.entiteId)!
        )
      )
    );

    const activeMatch = (
      this.filter === 'all' ||
      (this.filter === 'active' && user.estActif && !user.estInvitationEnAttente) ||
      (this.filter === 'inactive' && !user.estActif) ||
      (this.filter === 'invitation' && user.estInvitationEnAttente && user.tousLesRolesEntites && user.tousLesRolesEntites.length > 0)
    );

    const nameMatch = !this.selectedNames.length || this.selectedNames.includes(user.nom);

    const roleMatch = !this.selectedRoles.length || (
      user.tousLesRolesEntites?.some(role =>
        this.selectedRoles.includes(this.utilisateurService.obtenirDenominationRole(role.roleId))
      )
    );

    const emailMatch = !this.selectedEmails.length || this.selectedEmails.includes(user.email);

    const etiquetteMatch = !this.selectionEtiquette.length || (
      this.selectionEtiquette.every(selectedEtq =>
        (user.toutesLesEtiquettes ?? []).includes(selectedEtq)
      )
    );

    const searchMatch = !this.searchTerm || Boolean(
      Object.values(user).some(value =>
        value && value.toString().toLowerCase().includes(this.searchTerm.toLowerCase())
      ) ||
      user.toutesLesEtiquettes?.some(etiquetteId =>
        this.getEtiquetteName(etiquetteId).toLowerCase().includes(this.searchTerm.toLowerCase())
      ) ||
      user.tousLesRolesEntites?.some(roleEntite => {
        const roleName = this.utilisateurService.obtenirDenominationRole(roleEntite.roleId)?.toLowerCase() || '';
        const companyName = roleEntite.nomEntite?.toLowerCase() || '';
        return roleName.includes(this.searchTerm.toLowerCase()) ||
          companyName.includes(this.searchTerm.toLowerCase());
      })
    );

    return entiteMatch && activeMatch && nameMatch && roleMatch && emailMatch && searchMatch && etiquetteMatch;
  }

  resetFilters(): void {
    this.selectedEntreprises = [];
    this.selectedNames = [];
    this.selectedEmails = [];
    this.selectedRoles = [];
    this.selectionEtiquette = [];
    this.filter = 'active';
    this.searchTerm = '';
    this.sortColumn = '';
    this.sortDirection = '';
    this.pageIndex = 0;
    this.resetSelections();
    this.applyFilters();

    if (this.sort) {
      this.sort.active = '';
      this.sort.direction = '';
      this.sort._stateChanges.next();
    }
  }

  private resetSelections(): void {
    this.allSelected = false;
    this.anySelected = false;
    this.showEtiquettesMenu = false;
    this.utilisateurs.forEach(user => user.isSelected = false);
  }

  toggleFiltres(): void {
    this.afficherFiltreMobile = !this.afficherFiltreMobile;
    this.afficherFiltreBureau = !this.afficherFiltreBureau;
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.dataSource.sort = this.sort;
      this.sort.sortChange.subscribe(() => {
        this.paginator.pageIndex = 0;
      });
    }

    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.totalItems = this.utilisateurs.length;
      this.refreshDataSource();
    }
  }


  toggleMenu(user: UtilisateurListPilotageModel): void {
    user.isMenuOpen = !user.isMenuOpen;
    this.utilisateursFiltreEncours.forEach((u) => {
      if (u.utilisateurId !== user.utilisateurId) {
        u.isMenuOpen = false;
      }
    });
  }

  editUser(utilisateurId: number): void {
    this.router.navigate(['/edit-user', utilisateurId]);
  }

  obtenirCodeInvitation(utilisateurId: number): void {
    this.dialog.open(DetailInvitationDialogComponent, {
      width: '400px',
      data: { utilisateurId: utilisateurId }
    }).afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  selectAll(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.allSelected = isChecked;
    this.utilisateursFiltreEncours.forEach(user => user.isSelected = isChecked);
    this.updateAnySelected();
  }

  hasSelectedInvitationEnAttente(): boolean {
    return this.utilisateursFiltreEncours.some(utilisateur => utilisateur.isSelected && utilisateur.estInvitationEnAttente);
  }


  hasActiveSelectedUsers(): boolean {
    return this.utilisateursFiltreEncours.some(user =>
      user.isSelected &&
      user.estActif &&
      user.utilisateurId !== this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId
    );
  }

  toggleEtiquettesMenu(): void {
    this.showEtiquettesMenu = !this.showEtiquettesMenu;
  }
  ajouterDocument(utilisateurId: number) {
    this.router.navigate(['document-utlisateur/ajouter/' + utilisateurId])
  }

  rapportFormations(utilisateurId: number) {
    this.router.navigate(['contenus-managment/profil-utilisateur/complete/' + utilisateurId])
  }
  ajouterEtiquettes() {
    this.showEtiquettesMenu = false;

    const selectedUsers = this.utilisateursFiltreEncours
      .filter(user => user.isSelected)
      .map(user => ({
        utilisateurId: user.utilisateurId,
        tousLesRolesEntites: user.tousLesRolesEntites.filter(role => role.roleId === 3)
      }));

    const dialogRef = this.dialog.open(CommunEtiquetteComponent, {
      width: '500px',
      data: {
        users: selectedUsers,
        mode: 'add'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs().then(() => {
          this.allSelected = false;
          this.anySelected = false;
          this.showEtiquettesMenu = false;
          this.utilisateursFiltreEncours.forEach(user => user.isSelected = false);
        });
      }
    });
  }

  supprimerEtiquettes() {
    this.showEtiquettesMenu = false;

    const selectedUsers = this.utilisateursFiltreEncours
      .filter(user => user.isSelected)
      .map(user => ({
        utilisateurId: user.utilisateurId,
        tousLesRolesEntites: user.tousLesRolesEntites.filter(role => role.roleId === 3)
      }));

    const dialogRef = this.dialog.open(CommunEtiquetteComponent, {
      width: '500px',
      data: { users: selectedUsers, mode: 'remove' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs().then(() => {
          this.allSelected = false;
          this.anySelected = false;
          this.showEtiquettesMenu = false;
          this.utilisateursFiltreEncours.forEach(user => user.isSelected = false);
        });
      }
    });
  }


  toggleUserSelection(utilisateur: UtilisateurListPilotageModel): void {
    utilisateur.isSelected = !utilisateur.isSelected;
    this.updateAllSelected();
    this.updateAnySelected();
  }

  updateAllSelected(): void {
    this.allSelected = this.utilisateursFiltreEncours.every(user => user.isSelected);
  }

  updateAnySelected(): void {
    this.anySelected = this.utilisateursFiltreEncours.some(user => user.isSelected);
    if (!this.anySelected) {
      this.showEtiquettesMenu = false;
    }
  }

  openInviteDialogInvitUtilisateur(): void {
    const dialogRef = this.dialog.open(InviteUtilisateurDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs();
      }
    });
  }

  openInviteDialogInvitAdminPilote(): void {
    const dialogRef = this.dialog.open(InviteAdminPiloteDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs();
      }
    });
  }

  estPilote(): boolean {
    return this.utilisateurService.selectionEntiteUtilisateur.estRoot
      || this.utilisateurService.entiteUtilisateurSelectionnee.roleEntites
        .some(roleEntite => roleEntite.roleId === 1);
  }

  openInviteDialogCreerUtilisateursFictifs(): void {
    const dialogRef = this.dialog.open(CreerUtilisateursFictifsDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs();
      }
    });
  }

  openCreerUtilisateurTenantSSODialog(): void {
    const dialogRef = this.dialog.open(CreerUtilisateurTenantSSODialogComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs();
      }
    });
  }

  openCreerAdminPiloteTenantSSODialog(): void {
    const dialogRef = this.dialog.open(CreerAdminPiloteTenantSSODialogComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs();
      }
    });
  }


  desactiverUtilisateurs(): void {
    const selectedUsers = this.utilisateursFiltreEncours.filter(user =>
      user.isSelected && user.utilisateurId !== this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId
    );

    const userIds = selectedUsers.map(user => user.utilisateurId);

    const dialogRef = this.dialog.open(ConfirmationDesactiverDialogComponent, {
      width: '400px',
      data: { userIds: userIds }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs();
      }
    });
  }

  confirmerReenvoyerInvitations(): void {
    const selectedUsers = this.utilisateursFiltreEncours.filter(user => user.isSelected && user.estInvitationEnAttente);
    if (selectedUsers.length === 0) {
      return;
    }

    const userIds = selectedUsers.map(user => user.utilisateurId);

    const dialogRef = this.dialog.open(ConfirmationReenvoiInvitationDialogComponent, {
      width: '400px',
      data: { userIds: userIds }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs();
      }
    });
  }

  private chargementUtilisateurs(): Promise<void> {
    return new Promise((resolve) => {
      this.isLoading = true;
      this.utilisateurService.obtenirContexte().subscribe(
        res => {
          this.utilisateurService.contexteUtilisateur = res;
          this.utilisateurService.obtenirUtilisateurs(this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId).subscribe(res => {
            this.utilisateurs = res;
            this.utilisateursFiltreEncours = [...this.utilisateurs];
            this.populateFilterOptions();
            this.initializeFilteredOptions();
            this.loadState();
            this.applyFilters();
            this.isLoading = false;
            resolve();
          });
        },
        error => {
          console.error('Error loading users:', error);
          this.isLoading = false;
          resolve();
        }
      );
    });
  }

  onClickActiverUtilisateur(utilisateur: UtilisateurListPilotageModel): void {
    const invitationRequise = !utilisateur.ssoId; // Si pas de SSOId, invitation requise
    this.dialog.open(ChoixEntiteActiverDialogComponent, {
      width: '400px',
      data: { utilisateur: utilisateur, invitationRequise: invitationRequise }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.chargementUtilisateurs();
      }
    });
  }

  onClickDesactiver(utilisateur: UtilisateurListPilotageModel): void {
    var utilisateurIdListe = [utilisateur.utilisateurId];
    this.desactiverUtilisateur(utilisateurIdListe);
  }

  onClickReenvoyerInvitation(utilisateur: UtilisateurListPilotageModel): void {
    var utilisateurIdListe = [utilisateur.utilisateurId];
    this.renvoyerInvitations(utilisateurIdListe);
  }

  onClickforcerMotDePasse(utilisateur: UtilisateurListPilotageModel): void {
    const model: ForcerMotDePasseModel = {
      ssoId: utilisateur.ssoId!
    };

    this.utilisateurService.forcerMotDePasse(model).subscribe(
      (res) => {
        this.dialog.open(ConfirmationForcerMdpDialogComponent, {
          width: '700px',
          data: { email: utilisateur.email, password: res.newPassword }
        });
        this.chargementUtilisateurs();
      },
    );
  }

  onClickConvertirEnFictif(utilisateur: UtilisateurListPilotageModel): void {
    this.utilisateurService.convertirCompteEnCompteFictif(utilisateur.ssoId!).subscribe(
      (res) => {
        this.dialog.open(ConfirmationForcerMdpDialogComponent, {
          width: '700px',
          data: { email: utilisateur.email, password: res.newPassword }
        });
        this.chargementUtilisateurs();
      },
      (error) => {
        console.error('Error converting account to fictitious:', error);
        this.snackBar.open(
           this.translate.instant('COMMUN.OPERATION_NON_PERMISE'),
          this.translate.instant('COMMUN.CLOSE'),
          { duration: 5000 }
        );
      }
    );
  }
  private renvoyerInvitations(utilisateurIdListe: number[]) {
    this.utilisateurService.renvoyerInvitationsUtilisateurs(utilisateurIdListe).subscribe(
      () => {
        this.snackBar.open(
          this.translate.instant('USERS_MANAGEMENT.INVITATION_RESENT_SUCCESS'),
          this.translate.instant('USERS_MANAGEMENT.CLOSE'),
          { duration: 5000 }
        );
        this.chargementUtilisateurs();
      },
    );
  }

  private desactiverUtilisateur(utilisateurIdListe: number[]) {
    const desactiverModel: DesactiverUtilisateursModel = {
      utilisateursIds: utilisateurIdListe,
      entiteIdAccessibles: this.utilisateurService.contexteUtilisateur.entitesAccessibles.map(e => e.entiteId)
    };

    this.utilisateurService.desactiverUtilisateurs(desactiverModel).subscribe(
      (res: ResultDesactiverUtilisateursModel) => {
        if (res.utilisateursDansAutreEntites && res.utilisateursDansAutreEntites.length > 0) {
          this.snackBar.open(
            'Il est nécessaire de contacter le pilote pour désactiver ' + res.utilisateursDansAutreEntites[0] + ' car il est présent dans une autre entreprise.',
            'Fermer',
            { duration: 5000 }
          );
        }
        if (res.utilisateursSucces && res.utilisateursSucces.length > 0) {
          this.snackBar.open(
            'Utilisateur ' + res.utilisateursSucces[0] + ' désactivé avec succès.',
            'Fermer',
            { duration: 5000 }
          );
        }
        this.chargementUtilisateurs();
      },
      error => {
        console.error('Error deactivating user:', error);
      }
    );
  }

  getEtiquetteName(etiquetteId: number): string {
    const etiquette = this.utilisateurService.contexteUtilisateur.toutesLesEtiquettes.find(e => e.etiquetteId === etiquetteId);
    if (etiquette) {
      return this.etiquetteService.getNomLocalise(etiquette.locales);
    }
    return '';
  }

  getEtiquette(etiquetteId: number): EtiquetteModel {
    const etiquette = this.utilisateurService.contexteUtilisateur.toutesLesEtiquettes.find(e => e.etiquetteId === etiquetteId)!;
    return etiquette;
  }

  getEtiquetteColor(etiquetteId: number): string {
    const etiquette = this.utilisateurService.contexteUtilisateur.toutesLesEtiquettes.find(e => e.etiquetteId === etiquetteId);
    return etiquette ? etiquette.couleur : '';
  }

  obtenirCouleur(hexColor: string): string {
    hexColor = hexColor.replace('#', '');
    const r = parseInt(hexColor.substr(0, 2), 16);
    const g = parseInt(hexColor.substr(2, 2), 16);
    const b = parseInt(hexColor.substr(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  }

  get estRootLectureSeule(): boolean {
    return this.utilisateurService.selectionEntiteUtilisateur?.estRootLectureSeule || false;
  }

  get dateDebutDemo(): moment.Moment | null {
    const dateDebut = this.utilisateurService.entiteUtilisateurSelectionnee?.dateDebutDemo;
    if (!dateDebut) {
      return null;
    }

    const date = moment(dateDebut).local();

    return date.isValid() ? date : null;
  }
  get estModeDemo(): boolean {
    return this.utilisateurService.entiteUtilisateurSelectionnee?.estDemo || false;
  }
  
  get estLimiteUtilisateursAtteinte(): boolean {
    if (!this.estModeDemo) {
      return false;
    }

    const dateDebutDemo = this.dateDebutDemo;
    if (!dateDebutDemo) {
      return false;
    }

    const nombreUtilisateurs = this.nombreUtilisateursDepuisDebutDemo(dateDebutDemo);

    return nombreUtilisateurs >= this.DEMO_USER_LIMIT;
  }

  get messageTooltipLimite(): string {
    return this.estLimiteUtilisateursAtteinte ? this.translate.instant('USERS_MANAGEMENT.DEMO_USER_LIMIT_TOOLTIP') : '';
  }

  private nombreUtilisateursDepuisDebutDemo(dateDebutDemo: moment.Moment): number {
    return this.utilisateurs.filter(utilisateur => {
      if (!utilisateur.dateCreation) {
        return false;
      }
      const dateCreation = moment(utilisateur.dateCreation).local();

      return dateCreation.isSameOrAfter(dateDebutDemo);
    }).length;
  }

  paginer(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }

    this.utilisateursFiltreEncours.forEach(user => user.isMenuOpen = false);

    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.utilisateursAffiches = this.utilisateursFiltreEncours.slice(startIndex, endIndex);
    this.dataSource.data = this.utilisateursAffiches;
    this.changeDetectorRef.detectChanges();
    this.saveState();
  }


  private updatePaginatorLength(): void {
    if (this.paginator) {
      this.paginator.length = this.utilisateursFiltreEncours.length;
      this.totalItems = this.utilisateursFiltreEncours.length;
      this.paginator.page.emit();
      this.changeDetectorRef.detectChanges();
    }
  }

  refreshDataSource(): void {
    this.utilisateursFiltreEncours = this.utilisateurs;
    this.dataSource.data = this.utilisateursFiltreEncours;
    this.updatePaginatorLength();
  }

  exporterVersExcel(): void {
    const ids = this.utilisateursFiltreEncours.map(u => u.utilisateurId);
    if (!ids.length) return;
    const dialogRef = this.dialog.open(ConfirmationExportDialogComponent, {
      width: '600px',
      data: { exportLabelKey: 'USERS_MANAGEMENT.EXPORT_EXCEL' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        const codeLangue = this.translate.currentLang || 'fr';
        this.utilisateurService.exporterUtilisateurs(ids, codeLangue).subscribe(blob => {
          const now = new Date();
          const pad = (n: number) => n.toString().padStart(2, '0');
          const datetime = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
          const filename = `utilisateurs_${datetime}.xlsx`;
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.isLoading = false;
        }, () => {
          this.isLoading = false;
        });
      }
    });
  }

  exporterVersPdf(): void {
    const ids = this.utilisateursFiltreEncours.map(u => u.utilisateurId);
    if (!ids.length) return;
    const dialogRef = this.dialog.open(ConfirmationExportDialogComponent, {
      width: '600px',
      data: { exportLabelKey: 'USERS_MANAGEMENT.EXPORT_PDF' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        const codeLangue = this.translate.currentLang || 'fr';
        this.utilisateurService.exporterUtilisateursPdf(ids, codeLangue).subscribe(blob => {
          const now = new Date();
          const pad = (n: number) => n.toString().padStart(2, '0');
          const datetime = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
          const filename = `utilisateurs_${datetime}.pdf`;
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.isLoading = false;
        }, () => {
          this.isLoading = false;
        });
      }
    });
  }

  private saveState(): void {
    const state: UtilisateursManagmentState = {
      selectedEntreprises: this.selectedEntreprises,
      selectedNames: this.selectedNames,
      selectedEmails: this.selectedEmails,
      selectedRoles: this.selectedRoles,
      selectionEtiquette: this.selectionEtiquette,
      filter: this.filter,
      searchTerm: this.searchTerm,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };

    const contextId = this.utilisateurService.entiteUtilisateurSelectionnee?.entiteId;
    this.statePersistenceService.saveState(this.COMPONENT_KEY, state, contextId);
  }

  private loadState(): void {
    const contextId = this.utilisateurService.entiteUtilisateurSelectionnee?.entiteId;
    const savedState = this.statePersistenceService.loadState(this.COMPONENT_KEY, contextId);

    if (savedState) {
      const validatedState = validateUtilisateursManagmentState(savedState);

      this.selectedEntreprises = validatedState.selectedEntreprises;
      this.selectedNames = validatedState.selectedNames;
      this.selectedEmails = validatedState.selectedEmails;
      this.selectedRoles = validatedState.selectedRoles;
      this.selectionEtiquette = validatedState.selectionEtiquette;
      this.filter = validatedState.filter;
      this.searchTerm = validatedState.searchTerm;
      this.pageIndex = validatedState.pageIndex;
      this.pageSize = validatedState.pageSize;
    }
  }

}
